module.exports = __webpack_public_path__ + "static/media/kids_38.cbe47d16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_38.jpg
// module id = 5894
// module chunks = 0